import { AxiosRequestConfig } from 'axios'
import { CLOUDFRONT_WEBVIEW_CONTENT_BASE_URL, SOLUTION_ID } from 'common'

import { ITermsPendingAcceptanceRequest } from '../types'

export const getPrivacyPolicyAcceptanceContentEndpoint: AxiosRequestConfig = {
  method: 'GET',
  url: `${CLOUDFRONT_WEBVIEW_CONTENT_BASE_URL}/privacy-policy-acceptance/:entity/:language`,
}

export const requestTermsPendingAcceptanceBody: ITermsPendingAcceptanceRequest = {
  terms: [
    {
      org: 'BR',
      type: 'privacyNoticeUS',
      solutionId: SOLUTION_ID,
    },
    {
      org: 'US_BRANCH',
      type: 'privacyNoticeUS',
      solutionId: SOLUTION_ID,
    },
  ],
}
